import { Typography } from "@mui/material";

const FallbackTypography = ({ value, fallback = "N/A", ...props }) => {
  const displayValue = value ?? fallback;
  return <Typography {...props}>{displayValue}</Typography>;
};

export default FallbackTypography;